<template lang="html">
  <transition name="fade">
    <div class="prt-modal" v-if="show" @click="handleClick">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  methods: {
    handleClick(e) {
      if (e.target === this.$el) this.$emit('close');
    },
  },
  props: {
    show: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-modal
    width: 100%
    height: 100%
    background-color: black-54
    position: fixed
    top: 0
    left: 0
    z-index: 9999

    &.fade-enter-active,
    &.fade-leave-active
      transition: opacity 200ms ease

    &.fade-enter,
    &.fade-leave-to
      opacity: 0
</style>
